export const LOAD_MORE_DATA_START = "@data_table/load_more_data_start";
export const LOAD_MORE_DATA = "@data_table/load_more_data";
export const LOAD_MORE_DATA_STOP = "@data_table/load_more_data_stop";
export const UPDATE_STATE_VALUES = "@data_table/update_state_values";
export const REORDER_COLUMNS = "@data_table/reorder_columns";
export const TOGGLE_COLUMN_VISIBILITY = "@data_table/toggle_column_visibility";
export const TOGGLE_COLUMN_FIXED = "@data_table/toggle_column_fixed";
export const TOGGLE_SELECT_ALL = "@data_table/toggle_select_all";
export const TOGGLE_ROW_SELECTION = "@data_table/toggle_row_selection";
export const SET_SELECTED_ROWS = "@data_table/set_selected_rows";
export const SELECT_SINGLE_ROW = "@data_table/select_single_row";
export const SET_EXPORTABLE_COLUMNS = "@data_table/set_exportable_columns";
export const SET_COLUMNS_INITIAL_WIDTH =
  "@data_table/set_columns_initial_width";
export const TOGGLE_ROW_EXPANSION = "@data_table/toggle_row_expansion";
export const ALL_ROWS_SELECTED = "@data_table/all_rows_selected";
export const IS_TABLE_BUSY = "@data_table/is_loading";
export const COLUMN_RESIZE_END = "@data_table/column_resize_end";

export const createAction = type => payload => ({ type, payload });
export const updateStateValues = createAction(UPDATE_STATE_VALUES);
export const reorderColumns = createAction(REORDER_COLUMNS);
export const toggleColumnVisibility = createAction(TOGGLE_COLUMN_VISIBILITY);
export const toggleColumnFixed = createAction(TOGGLE_COLUMN_FIXED);
export const setColumnsInitialWidth = createAction(SET_COLUMNS_INITIAL_WIDTH);
export const toggleSelectAll = createAction(TOGGLE_SELECT_ALL);
export const toggleRowSelection = createAction(TOGGLE_ROW_SELECTION);
export const setSelectedRows = createAction(SET_SELECTED_ROWS);
export const toggleRowExpansion = createAction(TOGGLE_ROW_EXPANSION);
export const selectSingleRow = createAction(SELECT_SINGLE_ROW);
export const loadMoreDataStart = createAction(LOAD_MORE_DATA_START);
export const loadMoreData = createAction(LOAD_MORE_DATA);
export const loadMoreDataStop = createAction(LOAD_MORE_DATA_STOP);
export const setExportableColumns = createAction(SET_EXPORTABLE_COLUMNS);
export const allRowsSelected = createAction(ALL_ROWS_SELECTED);
export const isTableBusy = createAction(IS_TABLE_BUSY);
export const onColumnResizeEnd = createAction(COLUMN_RESIZE_END);
